import * as React from 'react'

export function CheckmarkIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27 9.00061L13 23L6 16.0006" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
